import { execFile } from 'node:child_process';

export function openBrowser(url: string): void {
  if (process.platform === 'win32') {
    // `start` is a cmd built-in; the empty string is the window title slot.
    execFile('cmd', ['/c', 'start', '', url], () => {});
    return;
  }
  const cmd = process.platform === 'darwin' ? 'open' : 'xdg-open';
  execFile(cmd, [url], () => {});
}
